<template>
  <div class="parent">

      <ResponsiveDesignLayer :isMedia="isMedia" :hasImage="image ? true : false" @isFlipped="resize">
      <template v-slot:left-column>
        <div class="flex-grow" v-if="image && image.isLinks">
          <div class="mx-1 mt-2 caption_dotted" >
            Related Painted Representations
            </div>
            <div class="lazy-grid-wrapper">
              <lazyTileGrid :centered="true" @loadMore="getNextResults" :items="relatedDepictions" :itemsCount="resAmount" ></lazyTileGrid>
            </div>
        </div>
        <kuchaStudiesPDFVIew v-if="image && image.isLKS" :leipzigKuchastudiesEntry="image.LKS"/>
        <osdImgViewer
          v-if="image && !image?.is3D && !image.isLKS && !image.isLinks"
          :images="[image]"
          ref="annoImg"
          class="flex-grow"
        />
        <Cave3DModelInf
          ref="cave3DModelInf"
          :elementID="'cave3DModel-' +  cave.caveID"
          class="flex-grow"
          style="flex: 1 1 auto; min-height: 0;"
          v-if="image && image?.is3D && relatedDepictionsLoaded"
          :item="cave"
          :relatedDepictions="relatedDepictions"
          :fokusOnFirstDepiction="true"
          @setShowTag="setShowTag"
          @setHoveredAnno="setHoveredAnno"
          @initIcoTree="setIcoAnnos"
          @setAnnoPrCount="setAnnoPrCount"
          @setHoveredIcos="setHoveredIcos"/>
        <v-tabs ref="tabs"
          class="mx-1 px-3 pt-1 my-1"
          v-if="images.length > 1"
          v-model="imageTab"
          :key="tabKey"
          centered
          light
          slider-color="yellow"
          return-object
          style="color:rgba(255, 255, 255, 0.2) !important;flex: 0 0 auto;"
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows

        >
          <v-tab
            v-for="(item, index) in images"
            :key="index"
            @click="setImage(item)"
            style="color:gba(255, 255, 255, 0.2) !important;"
          >
          <v-tooltip v-if="item && item.isLinks" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                x-large
              >
                mdi-image-multiple-outline
              </v-icon>
            </template>
            <span>Show Related Painted Representations</span>
          </v-tooltip>
          <div v-else-if="item && item.is3D">
          <v-icon x-large v-if="relatedDepictionsLoaded">
              mdi-rotate-3d
            </v-icon>
            <v-progress-circular v-else :value="20"></v-progress-circular>
          </div>

            <v-icon x-large v-else-if="item && item.isLKS">
              mdi-book-open-variant-outline
            </v-icon>

            <v-img  v-else-if="(imageValidDic['cave-' + item.caveSketchID]) ? imageValidDic['cave-' + item.caveSketchID].valid: false"
              :src="imageValidDic['cave-' + item.caveSketchID].thumbnail"
            >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            </v-img>
            <v-icon x-large v-else>mdi-lock</v-icon>
          </v-tab>
        </v-tabs>
      </template>
      <template v-slot:right-column>
        <div class="right-column" id="rightColumn" >
        <div class="tooltip-overlay">
          <v-menu
            v-model="showTag"
            activator="#tooltip-anchor"
            offset-x
            right
            :close-on-content-click="false"
            transition="scale-transition"
            content-class="floating-tooltip"
            max-width="calc(100vw - 20px)"
          >
            <div v-show="image?.is3D" style="width: fit-content; background-color: rgba(255, 255, 255, 0.9) !important;;">
              <Cave3DModelTooltip
                :hoveredAnno="hoveredAnno"
                :relatedDepictions="relatedDepictions"
                :darkText="true"
                @hideOverlayByClick="hideOverlayByClick"
              />
            </div>
          </v-menu>
        </div>
        <div class="text-overline grey--text text--darken-1 px-2 pt-2 mb-n2" style="line-height: 1; letter-spacing: 0.08em;">
          Cave
        </div>
        <v-card-title id="tooltip-anchor" class="text-h6 mx-0 px-2 pt-2 font-weight-bold" style="display: inline-block; line-height: 1.3;" >{{'Cave ' +getCaveLabel(cave)}}</v-card-title>
        <div ref="scroll-container" class="scroll-content mx-auto px3">
        <div style="min-height: fit-content;">
        <Cave3DModelFilterPanel
          v-if="image && image?.is3D && relatedDepictionsLoaded"
          ref="Cave3DModelFilterPanelMain"
          :renderVRMode="renderVRMode"
          :treeID="cave.caveID + '-tree1-iconographyID'"
          :locationFacets="locationFacets"
          @setLocationFacets="setLocationFacets"
          :filteredIcoAnnos="filteredIcoAnnos"
          @setIcoAnnos="setIcoAnnos"
          :annoPrCount="annoPrCount"
          @setAnnoPrCount="setAnnoPrCount"
          :changedLocationInput="changedLocationInput"
          :prepLocationAggs="prepLocationAggs"
          :updateicoSelectedParent="updateicoSelectedParent"
          :annoPreSelected="icoSelected"
          @setIcoSelected="setIcoSelected"
          :setLocations="setLocations"
          :locationsPreSet="selectedLocations"
          @setLocations="setLocations"
          :hoveredIcos="hoveredIcos"
        />
        </div>
        <div :key="item_name" v-for="(item_value, item_name) in caveInfo">
          <div class="mx-1 mt-2 caption_dotted" >
            {{ item_name }}
          </div>
          <div v-if="item_name=='Related Chronological Discussions'">
            <foruminf heading="Related Chronological Discussions" :newPosts="false" @getComments="getComments()" :discussions="discussions" :chronologicalRange="getChronologicalRange"></foruminf>
          </div>
          <v-list-item two-line v-for="(value, name, index) in item_value" :key=index>
            <v-list-item-content v-if="name !== 'Copyright'">
              <v-list-item-title >{{name}}</v-list-item-title>
              <div style="white-space: pre-line;padding:0px 0px 0px 10px;">{{value}}</div>
            </v-list-item-content>
            <div v-if="(name === 'Copyright')" style="display: inline-block;white-space: normal" v-html="name + ': ' + value"></div>
          </v-list-item>
          <div v-if="item_name === 'Bibliography'" class="mx-5">
            <v-list-item>
              <v-list-item-content>
                <div class="mb-2" v-for="annotatedBibliography in cave.relatedBibliographyList" :key="annotatedBibliography.annotatedBibliographyID">
                  <a v-if="bibliographyHasLink(annotatedBibliography)" target=”_blank”   :href="getBibUrl(annotatedBibliography)" v-html="getBibTitle(annotatedBibliography)"></a>
                  <div v-else v-html="getBibTitle(annotatedBibliography)"> </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>


      <div v-show="versions.length>1">
        <v-divider></v-divider>
          <div class="d-flex pa-2 mx-10 mb-1" >
          <v-combobox
          style="width:50%"
            class="d-flex justify-center align-center "
            v-model="version"
            :items="versions"
            label="Select Version"
            outlined
            dense
            item-text = "date"
            item-value="_id"
          ></v-combobox>
          </div>
      </div>
        </div>
      </div>

      </template>
      </ResponsiveDesignLayer>

</div>

</template>

<script>
import {getCaveLabel, getChronologicalRange,getLeipzigKuchastudiesEntries, bibliographyHasLink,getBibTitle} from  "@/utils/helpers"
import {getItemByIdLimited, getVersionsOfEntry, getVersionOfEntry, getCommentsByItems} from '@/services/repository'
import Cave3DModelInf from '../components/cave3DModelInf.vue'
import Foruminf from '../components/foruminf.vue'
import ResponsiveDesignLayer from './ResponsiveDesignLayer.vue'
import osdImgViewer from "./osdImgViewer.vue"
import lazyTileGrid from './lazyTileGrid.vue'
import Cave3DModelTooltip from './Cave3DModelTooltip.vue'
import Cave3DModelFilterPanel from './Cave3DModelFilterPanel.vue'


export default {

  name: 'caveInf',
  components: {
    Foruminf, Cave3DModelInf, Cave3DModelFilterPanel, ResponsiveDesignLayer, osdImgViewer,lazyTileGrid, Cave3DModelTooltip
  },
  props: {
    caveDefault: {},
    showRelatedDepictions: {
      type: Boolean,
      default: true
    },
    loadVersions: {
      type: Boolean,
      default: true
    },
    setWidth: true
  },
  data () {
    return {
      show: false,
      show3DModel:false,
      relatedDepictionsLoaded: false,
      tab:[],
      tooltipTarget: null,
      cave:{},
      tabKey:0,
      imageTab:0,
      relatedDepictions:[],
      caveScatches:[],
      version:null,
      versions:['current'],
      showVersions: false,
      discussions: [],
      resAmount: 0,
      images: [],
      image: null,
      newDesign: true,
      hoveredAnno: {},
      showTag: true,
      renderVRMode:false,
      locationFacets: [],
      icoAnnos: [],
      annoPrCount: {},
      icoSelected: [],
      selectedLocations: [],
      hoveredIcos: [],
    }
  },
  computed: {

    imageValidDic (){
      return this.$store.getters.getImageValidDic ? this.$store.getters.getImageValidDic : {}
    },

    isImageSet(){
      this.$log.debug("isImageSet:", this.image, Object.keys(this.image).length > 0);
      return Object.keys(this.image).length > 0
    },
    isMedia(){
      for (const image of this.images){
        if (image?.is3D || image.isLKS){
          return true
        }
      }
      return false
    },
filteredIcoAnnos() {
    if (!this.icoAnnos || this.icoAnnos.length === 0) return []

    const filterTree = (nodes) => {
      return nodes
        .filter(node => this.annoPrCount[node.iconographyID] > 0)
        .map(node => {
          if (node.children) {
            return { ...node, children: filterTree(node.children) };
          }
          return node;
        });
    };

    return filterTree(this.icoAnnos);
  },

    getChronologicalRange(){
      return getChronologicalRange()
    },
    paddingCaveCard(){
      const padding = this.cave.caveID === -1 ? 'pb-1' : ''
      this.$log.debug(this.cave.caveID, "padding", padding);
      return padding
    },

    caveInfo (){
      var caveInfo = {}
      var basciInf = {}
      if (this.cave.officialNumber){
        basciInf["Official Number"] = this.cave.officialNumber
      }
      if (this.cave.historicName){
        basciInf["Historical Name"] = this.cave.historicName
      }
      if (this.cave.optionalHistoricName){
        basciInf["Optional Historical Name"] = this.cave.optionalHistoricName
      }
      if (this.cave.firstDocumentedBy){
        basciInf["First Documented By"] = this.cave.firstDocumentedBy
      }
      if (this.cave.firstDocumentedInYear){
        basciInf["First Documented in Year"] = this.cave.firstDocumentedInYear
      }
      if (this.cave.caveGroupID){
        basciInf["Cave Group"] = this.cave.caveGroupID
      }
      if (this.cave.siteID){
        basciInf["Site"] = this.cave.site.name
      }
      if (this.cave.districtID){
        basciInf["District"] = this.cave.district.name
      }
      if (this.cave.regionID){
        basciInf["Region"] = this.cave.region.englishName
      }
      if (Object.keys(basciInf).length > 0){
        caveInfo['Basic Information'] = basciInf
      }
      if (this.image && this.image.caveSketchID){

        caveInfo["Shown Image"] = {
          // "Title": this.image.title,
          "Filename": this.image.caveSketchID + "." + this.image.imageType,
        }
      }
      if (this.discussions.length > 0){
        caveInfo['Related Chronological Discussions'] = ''
      }
      var caveLayout = {}
      var caveMeasurements = {}
      if (this.cave.caveType){
        caveLayout["Cave Type"] = this.cave.caveType.nameEN
      }
      var ceilingTypes = ""
      var plasticalItems = ""
      if ( this.cave.caveAreaList){
        for (var caveArea of this.cave.caveAreaList){
          var mesures = ""
          if (caveArea.ceilingType1){
            ceilingTypes += caveArea.caveAreaLabel + ": " + caveArea.ceilingType1.name + "\n"
          }
          if (caveArea.ceilingType2){
            ceilingTypes += caveArea.caveAreaLabel + ": " + caveArea.ceilingType1.name + "(optional second type)\n"
          }
          if (caveArea.expeditionLength > 0){
            mesures += "Length (Expedition Measurement): " + caveArea.expeditionLength.toString() + " m\n";
          }
          if (caveArea.expeditionWidth > 0){
            mesures += "Width (Expedition Measurement): " + caveArea.expeditionWidth.toString() + "m \n";
          }
          if (caveArea.expeditionTotalHeight > 0){
            mesures += "Total Height (Expedition Measurement): " + caveArea.expeditionTotalHeight.toString() + "m \n";
          }
          if (caveArea.expeditionWallHeight > 0){
            mesures += "Wall Height (Expedition Measurement): " + caveArea.expeditionWallHeight.toString() + "m \n";
          }
          if (caveArea.modernMaxHeight > 0){
            mesures += "Maximal Height (Modern Measurement): " + caveArea.modernMaxHeight.toString() + " m\n";
          }
          if (caveArea.modernMaxHeight > 0){
            mesures += "Maximal Height (Modern Measurement): " + caveArea.modernMaxHeight.toString() + " m\n";
          }
          if (caveArea.modernMaxLength > 0){
            mesures += "Maximal Length (Modern Measurement): " + caveArea.modernMaxLength.toString() + " m\n";
          }
          if (caveArea.modernMaxWidth > 0){
            mesures += "Maximal Width (Modern Measurement): " + caveArea.modernMaxWidth.toString() + " m\n";
          }
          if (caveArea.modernMinHeight > 0){
            mesures += "Minimal Height (Modern Measurement): " + caveArea.modernMinHeight.toString() + " m\n";
          }
          if (caveArea.modernMinLength > 0){
            mesures += "Minimal Length (Modern Measurement): " + caveArea.modernMinLength.toString() + " m\n";
          }
          if (caveArea.modernMinWidth > 0){
            mesures += "Minimal Width (Modern Measurement): " + caveArea.modernMinWidth.toString() + " m\n";
          }
          if (mesures !== ""){
            caveMeasurements["Measurements of " + caveArea.caveAreaLabel] = mesures
          }
        }
      }
      ceilingTypes += ""
      caveLayout["Ceiling Types"] = ceilingTypes
      if (Object.keys(caveLayout).length > 0){
        caveInfo['Layout'] = caveLayout
      }
      if (Object.keys(caveMeasurements).length > 0){
        caveInfo['Measurements'] = caveMeasurements
      }
      var description = ""
      if (this.cave.findings){
        description["findings"] = this.cave.findings
      }
      if (this.cave.notes){
        description["notes"] = this.cave.notes
      }
      if (this.cave.hasSculptures) {
        plasticalItems += "has sculptures\n"
      }
      if (this.cave.hasClayFigures) {
        plasticalItems += "has clay figures\n"
      }
      if (this.cave.hasVolutedHorseShoeArch) {
        plasticalItems += "has voluted horse shoe arch\n"
      }
      if (this.cave.hasHolesForFixationOfPlasticalItems) {
        plasticalItems += "has holes for fixation of plastical items Horse Shoe Arch\n"
      }
      if (this.cave.hasWoodenConstruction) {
        plasticalItems += "has wooden construction\n"
      }
      if (plasticalItems !== ""){
        caveInfo["Additional Objects"] = plasticalItems
      }
      if (description !== ""){
        caveInfo["Description"] = description
      }
      if (this.cave.relatedBibliographyList){
        if (this.cave.relatedBibliographyList?.length > 0){
          caveInfo["Bibliography"] = {}
        }
      }
      return caveInfo
    }
  },
  methods: {
    bibliographyHasLink(bib){
      return bibliographyHasLink(bib)
    },
    getBibUrl(bib){
      if (bib.uri){
        return bib.uri
      }
      if (bib.url){
        return bib.url
      }
      return ""
    },

    hideOverlayByClick(){
      this.$log.debug("hideOverlayByClick in caveInf")
      this.$refs['cave3DModelInf'].hideOverlayByClick()
    },
    setLocations(locations){
      this.selectedLocations = locations
    },
    setLocations(locations){
      this.$refs['cave3DModelInf'][0].setLocations(locations)
    },
    setHoveredIcos(hoveredIcos){
      this.$log.debug("setHoveredIcos in caveInf", hoveredIcos)
      this.hoveredIcos = hoveredIcos
    },
    getBibTitle(bib){
      return getBibTitle(bib)
    },
    setIcoSelected(icoSelected){
      this.$log.debug("setIcoSelected in caveInf", icoSelected)
      this.icoSelected = icoSelected
    },
    updateicoSelectedParent(icoSelected){
      this.$log.debug("updateicoSelectedParent in caveInf", icoSelected, this.$refs)
      this.$refs['cave3DModelInf'].updateicoSelectedParent(icoSelected)
    },
    prepLocationAggs(){
      this.$refs['cave3DModelInf'].prepLocationAggs()
    },
    changedLocationInput(value){
      this.$refs['cave3DModelInf'].changedLocationInput(value)
    },
    setAnnoPrCount(annoPrCount){
      this.$log.debug("setAnnoPrCount in caveInf", annoPrCount)
      this.annoPrCount = annoPrCount
    },
    setIcoAnnos(icoAnnos){
      this.$log.debug("setIcoAnnos in caveInf", icoAnnos)
      this.icoAnnos = icoAnnos
    },
    setLocationFacets(locationFacets){
      this.$log.debug("setLocationFacets in caveInf", locationFacets)
      this.locationFacets = locationFacets
    },
    setShowTag(showTag){
      this.showTag = showTag
      this.$log.debug("setShowTag in caveInf", showTag)
    },
    setHoveredAnno(hoveredAnno){
      this.hoveredAnno = hoveredAnno
    },
    setImage(image){
      this.image = image
      this.$log.debug("set image", image)
      if (this.$refs['wallTree']) {
        this.$refs['wallTree'][0].updateAll(true)
      }
    },
    fillPicsContainer(){
      this.images = []
      for (var img of this.cave.caveSketchList){
          this.images.push(img)
      }
      if (this.cave.cave3DModel){
        this.images.push({
          "is3D": true
        })
      }
      const lksList = getLeipzigKuchastudiesEntries(this.cave.relatedBibliographyList)
      this.$log.debug("lksList", lksList)
      if (lksList.length > 0){
        this.$log.debug("has lksEntries", lksList)
        for (const lks of lksList){
          this.images.push({
            "isLKS": true,
            "LKS": lks
          })
          this.$log.debug("added lksEntry", this.images)
        }
      }
      this.$log.debug('this.images', this.images)
    },
    resize(){
    },
    getCaveURL(){
      return "/cave/" + this.cave.caveID
    },
    getNextResults(from, size){
      // this.postSearch(from, size)
    },
    postSearch(from, size){
      var params = {}
      params['type'] = "cave.caveID"
      if (this.cave.caveID){
        params['id'] = this.cave.caveID
      } else {
        params['id'] = this.$route.params.id
      }
      const _self = this
      getItemByIdLimited(params, from, size)
        .then( res => {
          _self.resAmount = res.data.hits.total.value
          for (let result of res.data.hits.hits){
            _self.relatedDepictions.push(result._source)
          }
          if (_self.resAmount > from + size){
            _self.postSearch(from + size, size)
          } else {
            _self.$log.debug("adding links")
            _self.relatedDepictionsLoaded = true
          }
        }).catch(function (error) {
          _self.$log.debug(error)
        })

    },
    getRelatedDepictions(){
      this.relatedDepictions = []
      this.relatedDepictionsLoaded = false
      this.$log.debug("showing depictions enabled. sending request now.")
      this.postSearch(0, 20)
    },
    getCaveWidth(){
      this.$log.debug("window.innerWidth", window.innerWidth);
      return parseInt((window.innerWidth / 2) - 70)
    },
    getCaveRes(){
      this.caveScatches = []
      if (this.cave.caveSketchList){
        for (let item of this.cave.caveSketchList){
          var res = process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fcavesketches%2F" + item.caveSketchID + "." + item.imageType + "/full/" + this.getCaveWidth() + ",/0/default.jpg"
          this.caveScatches.push(res)
        }
      }
    },
    getCaveLabel(entry){
      this.$log.debug("cave:", entry);
      return getCaveLabel(entry)
    },
    getComments(){
      const _self = this
      getCommentsByItems([this.cave.caveID], [], [], [])
        .then( res => {
          _self.$log.debug("recieved discussions.", res.data.hits.hits)
          _self.discussions = res.data.hits.hits
        }).catch(function (error) {
          _self.$log.debug(error)
          return null
        })
    }
  },
  mounted:function () {
    this.tooltipTarget = this.$refs.rightColumn
    this.fillPicsContainer()
    this.$store.dispatch('buildImageValidDic', this.cave.caveSketchList)
    this.image = this.images[0]
    this.getCaveRes()
    if (this.showRelatedDepictions){
      this.getRelatedDepictions()
    }
    this.getComments()

  },
  beforeMount:function () {
    this.$log.debug("beforemount:", this.caveDefault);
    this.cave = this.caveDefault
    const _self = this
    if (this.loadVersions){
      getVersionsOfEntry(this.caveDefault)
        .then( res => {
          this.$log.debug("recieved versions.", res.data.hits.hits)
          this.versions = res.data.hits.hits
          for (let v of this.versions){
            v.date = new Date(v._source.timestamp)
          }
          if (this.versions.length > 0){
            this.versions[this.versions.length - 1].date = this.versions[this.versions.length - 1].date + " - (current)"
          }
          this.version = this.versions[this.versions.length - 1]
          this.$log.debug("versions:", this.versions);
        }).catch(function (error) {
          _self.$log.debug(error)
          return null
        })
    }
  },
  watch: {
    showTag(newVal, oldVal) {
      this.$log.debug("showTag changed in cavwInfo!", newVal);
      if (newVal) {
      }
    },
    cave(newVal, oldVal){
      console.log("cave changed!", newVal, this.update);
    },
    relatedDepictions(newVal, oldVal){
      this.$log.debug("relatedDepictions changed!", newVal, this.update);
      var image = null
      if (newVal.length > 0){
        var foundRelatedDepictionsTab = false
        for (image of this.images){
          if (image.isLinks){
            foundRelatedDepictionsTab = true
            break
          }
        }
        if (!foundRelatedDepictionsTab){
          this.images.push({
            "isLinks": true
          })
          if (!this.image){
            this.image = this.images[this.images.length - 1]
          }

        }
      } else {
        for (image of this.images){
          if (image.isLinks){
            this.images.splice(this.images.indexOf(image), 1)
            break
          }
        }
      }
    },
    version(newVal, oldVal){
      if (newVal != null){
        getVersionOfEntry(newVal._id)
          .then( res => {
            // this.cave = res.data._source.content
          }).catch(function (error) {
            this.$log.debug(error)
            return null
          })
      }
    }
  },

}
</script>

<style lang="css">

.v-list-item__title{
  margin-bottom: 5px;
}
.v-tab {
  padding: 8px;
  min-width: 20px;
}
.tooltip-wrapper {
  overflow: hidden;
  display: block;
}
.floating-tooltip {
  min-width: fit-content !important;
}

/* Transition aktiviert */
.tooltip-slide-enter-active,
.tooltip-slide-leave-active {
  transition: all 0.3s ease;
}

/* Anfangszustand beim Einblenden */
.tooltip-slide-enter {
  opacity: 0;
}

/* Zielzustand nach dem Einblenden */
.tooltip-slide-enter-to {
  opacity: 1;
}


</style>
